import { Component, OnInit, ViewChild, ElementRef, NgZone, ApplicationRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerPostPut, EMainContact, AccountService } from '../../../api';
import { MapsAPILoader } from '@agm/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastService } from '../../../../shared/service/toast.service';
import { DataService } from '../../../../shared/service/data.service';
import { PasswordComponent } from '../../../settings/components/password/password.component';

declare var require: any;
const codes: any = require('../../../../../assets/codes.json');

@Component({
  selector: 'app-customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.scss']
})
export class CustomerFormComponent implements OnInit {
  @ViewChild('search') public searchElement: ElementRef;
  data: any;
  keys = Object.keys;
  EMainContact;
  customerForm: FormGroup;
  countries;
  update = false;
  contacts;
  languages = [
    { code: 'en', name: 'English' },
    { code: 'da', name: 'Danish' }
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private as: AccountService,
    private toast: ToastService,
    private dt: DataService,
    private modalService: NgbModal,
    private app: ApplicationRef,
    private mapsAPILoader: MapsAPILoader, private ngZone: NgZone
  ) {
    this.countries = this.dt.listCountry;
  }

  ngOnInit() {
    this.EMainContact = this.dt.mainContact;
    this.customerForm = new FormGroup({
      fullname: new FormControl(null, [
        Validators.required,
        Validators.maxLength(80),
      ]),
      email: new FormControl({ value: '', disabled: false }, {
        validators: Validators.email,
        updateOn: 'blur'
      }),
      address: new FormControl(null, [
        Validators.required,
      ]),
      contact: new FormControl(null, [
        Validators.required,
      ]),
      password: new FormControl({ value: '', disabled: false }),
      repassword: new FormControl({ value: '', disabled: false }),
      city: new FormControl(null, [
        Validators.required,
      ]),
      country: new FormControl(null, [
        Validators.required,
      ]),
      postal: new FormControl(null, [
        Validators.required,
      ]),
      phone: new FormControl(''),
      language: new FormControl(''),
      mail: new FormControl(false),
      generate: new FormControl(true)
    }, validPassword);
    if (!this.update) {
      this.data.mainContact = EMainContact.EmailNotification;
      this.data.language = 'da';
    }

    this.mapsAPILoader.load().then(() => {
      this.app.tick();
      const autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement,
        { componentRestrictions: { country: 'dk' } });
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.address.setValue(place.formatted_address);
          place.address_components.forEach(element => {
            if (element.types[0] === 'locality') {
              this.data.city = element.long_name;
            }
            if (element.types[0] === 'country') {
              this.data.country = element.short_name;
            }
            if (element.types[0] === 'postal_code') {
              this.data.postalCode = element.long_name;
            }
          });
          this.data.lat = place.geometry.location.lat();
          this.data.lng = place.geometry.location.lng();
          this.app.tick();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
        });
      });
    });

    if (this.update) {
      this.customerForm.validator = null;
      this.customerForm.controls.email.disable();
    }
  }

  get fullname() { return this.customerForm.get('fullname'); }
  get email() { return this.customerForm.get('email'); }
  get address() { return this.customerForm.get('address'); }
  get postal() { return this.customerForm.get('postal'); }
  get city() { return this.customerForm.get('city'); }
  get country() { return this.customerForm.get('country'); }
  get contact() { return this.customerForm.get('contact'); }
  get password() { return this.customerForm.get('password'); }
  get repassword() { return this.customerForm.get('repassword'); }

  validateForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateForm(control);
      }
    });
  }

  checkForm() {
    if (!this.data.autoGeneratePassword) {
      this.customerForm.controls.password.disable();
      this.customerForm.controls.password.reset();
      this.customerForm.controls.repassword.disable();
      this.customerForm.controls.repassword.reset();
      this.customerForm.controls.mail.disable();
      this.customerForm.get('mail').setValue(true);
    } else {
      this.customerForm.controls.password.enable();
      this.customerForm.controls.repassword.enable();
      this.customerForm.controls.mail.enable();
    }
  }

  outFocus() {
    this.email.setValue(this.email.value.trim());
  }

  resetPassword() {
    const modalRef = this.modalService.open(PasswordComponent, { backdrop: 'static', centered: true });
    modalRef.componentInstance.email = this.data.email;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  saveModal() {
    if (this.customerForm.valid) {
      if (this.update) {
        this.as.apiAccountsUpdateCustomerPut(this.data)
          .subscribe(() => {
            this.toast.showSuccess('CUSTOMER_EDIT_SUCCESS');
            this.activeModal.close(this.data);
          });
      } else {
        this.as.apiAccountsNewCustomerPost(this.data)
          .subscribe(() => {
            this.toast.showSuccess('CUSTOMER_ADD_SUCCESS');
            this.activeModal.close(this.data);
          });
      }
    } else {
      this.validateForm(this.customerForm);
    }
  }

  postalChange() {
    const index = codes.findIndex((x: any) => x.code == this.data.postalCode);
    if (index === -1) {
      this.data.city = '';
    } else {
      this.data.city = codes[index].city;
    }
  }
}

function validPassword(form: FormGroup): { [key: string]: boolean } {
  if (!form.get('generate').value) {
    if (!form.get('password').value) {
      return { 'invalidPassword': true };
    } else {
      if (form.get('password').value.length < 6 || form.get('password').value.length > 100) {
        return { 'invalidPassword': true };
      }
      if (form.get('password').value !== form.get('repassword').value) {
        return { 'invalidRepassword': true };
      }
    }
  }
  return null;
}
